import React from 'react';
import PropTypes from 'prop-types';
import {getText} from 'helpers/text-helper';
import Button from 'components/ui/button/button';
import LanguageSelectDropdown from 'components/ui/language-select-dropdown/language-select-dropdown';
import './settings.scss';

const Settings = ({isAdmin, languageId, email, deviceInfo, gameData, goToPage, setLanguageId, handleLogout}) => {
	const gameStartText = (gameData
		? getText('pages_gameStartDescription', languageId)
		: getText('pages_gameStartWelcome', languageId)
	);

	const handleSelectLanguage = (newLanguageId) => {
		setLanguageId(newLanguageId);
	};
	return (
		<div className={'Settings ' + deviceInfo.orientation}>
			{/* Select language */}
			<div className="Settings-selectLanguage">
				<LanguageSelectDropdown 
					languageId={languageId}
					layout="facilitator"
					deviceInfo={deviceInfo}
					handleSelectLanguage={handleSelectLanguage}
				/>
			</div>

			{/* Settings page */}
			<div className={'Settings-content' + (gameData ? '' : ' newUser')}>
				<div className='Settings-text'><span>{gameStartText}</span></div>
				<div className={'Settings-buttons' + (!gameData ? ' center' : '')}>
					<div className='Settings-button'>
						<Button
							classes={['orange', 'fullHeight']}
							text={getText('general_newGame', languageId)}
							onClick={() => {goToPage('create-game');}}
						/>
					</div>
					{gameData && <div className='Settings-button'>
						<Button
							classes={['orange', 'fullHeight']}
							text={getText('general_continueGame', languageId)}
							onClick={() => {goToPage('game-intro');}}
						/>
					</div>}
				</div>
			</div>



			{/* Logout btn */}
			<div className='Settings-logoutBtn'>
				<Button
					text={getText('general_logout', languageId)}
					classes={['orange', 'logout', 'facilitator']}
					onClick={() => {handleLogout();}}
				/>
			</div>

			{/* Stats btn */}
			{isAdmin && <div className='Settings-statsBtn'>
				<Button
					text={getText('stats_stats', languageId)}
					classes={['orange']}
					onClick={() => {goToPage('stats');}}
				/>
			</div>}
		</div>
	);
};

Settings.propTypes = {
	isAdmin: PropTypes.bool.isRequired,
	languageId: PropTypes.string.isRequired,
	email: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	gameData: PropTypes.object,
	goToPage: PropTypes.func.isRequired,
	setLanguageId: PropTypes.func.isRequired,
	handleLogout: PropTypes.func.isRequired,
};

export default Settings;